// @flow
import React, {useState} from 'react';
import {useGetProductsQuery} from "../../../api/featureflowApi";
import LoadingOverlay from "../../../components/LoadingOverlay";
import PerSeatProduct from "./PerSeatProduct";
import FreeProduct from "./FreeProduct";
import {Col, Nav, NavItem, Row} from "react-bootstrap";
import EnterprisePricingPlanNew from "./EnterprisePricingPlanNew";

const AvailableProducts = () => {
    const {data: products, isLoading} = useGetProductsQuery();
    const [interval, setInterval] = useState('month');
    if (isLoading) {
        return <LoadingOverlay visible={isLoading}/>
    }

    const handleSelect = () => {
        setInterval(interval === 'year' ? 'month' : 'year');
    }
    return (
        <>
                <Row>
                    <Col xs={12} className="show-grid" style={{textAlign: 'center', marginBottom: '15px'}}>
                        <div>
                            <Nav bsStyle="pills" activeKey={interval === 'month' ? 1 : 2} onSelect={handleSelect}>
                                <NavItem eventKey={1}>
                                    Monthly
                                </NavItem>
                                <NavItem eventKey={2} title="Yearly">
                                    Yearly
                                </NavItem>
                            </Nav>
                        </div>
                    </Col>
                </Row>
            <Row>
            <FreeProduct />
            {
                products?.map(product => {
                    return (
                        <React.Fragment key={product.id}>
                            {                                
                                <PerSeatProduct
                                    product={product}
                                    visiblePrice={interval}
                                />
                            }
                        </React.Fragment>
                    )
                })}
                <EnterprisePricingPlanNew/>
            </Row>

        </>
    )
}

export default AvailableProducts;
